import errorMessages from "./errorMessages";

// The purpose of this map is to enable us to begin maintaining the constant text of the page on the frontend.

const textMap: Record<string, string> = {
  ...errorMessages,
};

export default textMap;
